import { render, staticRenderFns } from "./GetLocationBox24.vue?vue&type=template&id=9fa938f8&scoped=true&"
import script from "./GetLocationBox24.vue?vue&type=script&lang=js&"
export * from "./GetLocationBox24.vue?vue&type=script&lang=js&"
import style0 from "./GetLocationBox24.vue?vue&type=style&index=0&id=9fa938f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa938f8",
  null
  
)

export default component.exports